<template>
  <el-container>
    <el-header
      style="height:50px;padding: 0 19px ;background: #f7f7f7;justify-content: space-between;align-items: center;"
    >
      <header-crunb style="font-size:1rem;font-weight:700" :crumbList="crumbList"></header-crunb>

      <el-button @click="gopage" style="float:right;background: #f7f7f7;border:none;">返回上一页</el-button>
    </el-header>
    <el-main style="background:white">
      <div class="product">
        <img class="image" :src="imgUrl" alt />
        <div class="title">名称: {{ title }}</div>
        <div class="num">库存:{{ inventory }}</div>
      </div>
      <el-form :inline="true" class="form-bottom">
        <el-form-item label="     年级  :" style="font-weight:700;font-size:1rem">
          <el-select @change="classList" v-model="grade" placeholder="请选择年级" style="width:170px" clearable @clear="getclearuser">
            <el-option
              v-for="(item,index) in getGradeList"
              :key="index"
              :label="item.gradeName"
              :value="item.grade"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级  :" style="font-weight:700;font-size:1rem">
          <el-select v-model="classCode" placeholder="请选择班级" style="width:170px"
          clearable @clear="getclear">
            <el-option
              v-for="(item,index) in getClassList"
              :key="index"
              :label="item.className"
              :value="item.classCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名 :" style="font-weight:700;font-size:1rem">
          <el-input v-model="keyword" placeholder="请输入姓名..." style="width:170px" clearable @clear="getclear"></el-input>
        </el-form-item>
        <el-form-item label="学号:" style="font-weight:700;font-size:1rem">
          <el-input v-model="studentNum" placeholder="请输入学号..." style="width:170px" clearable @clear="getclear"></el-input>
        </el-form-item>
        <el-button style="background:#21caaa;color:#fff" @click="search">查询</el-button>
        <!-- <el-button type="primary"  @click="dialogVisibleFind = true" style="float:right">扫码查找学生</el-button>    -->
      </el-form>

      <!-- 学生详情 -->
      <div class="table-phone" @request="onRequest()">
        <div class="phone" v-for="(item, id) in list" :key="item.id">
          <div class="img-group">
            <img :src="getUserLogo(item)" alt />
            <div class="img-tip">{{ item.userName }}</div>
          </div>
          <button
          style="background:none"
            :class="item.currScore >= scoreList ? 'active' : ''"
            @click="exchange(item)" :disabled="item.currScore<scoreList"
          >{{ item.currScore >= scoreList ? "兑  换" : "(积分不足)" }}</button>
        </div>
      </div>
      <!-- 充值弹框 -->
      <el-dialog title="兑换" :visible.sync="dialogVisibleExchange" width="35%" center>
        <div style="border-bottom: solid #f2f2f2 2px;margin-top: -1rem;"></div>
        <span>
          <div style="margin-top:1rem;position: relative;">
            <div class="red">
              <div style="margin-bottom:0.8rem;text-align: left;">
                学生姓名:
                <span class="red">{{ form.userName }}</span>
              </div>
              <div style="float:right;position: absolute;right:0;top:0">
                <div style="margin-bottom:0.8rem;text-align: left;">
                  班级:
                  <span class="red">{{ form.gradeName }}{{ form.className }}</span>
                </div>
                <div style="text-align: left;">
                  当前积分:
                  <span class="red">{{ form.currScore }}分</span>
                </div>
              </div>
              <div style="text-align: left;">
                学号:
                <span class="red">{{ form.studentNum }}</span>
              </div>
            </div>
            <div style="margin-top:0.8rem;font-size: 1rem;color:#8b888b;text-align: left">
              即将扣减的积分:
              <i class="blue">{{ scoreList }}分</i>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button
            style="background-color:#21caa8;color:#fff;width:100px"
            @click="exchangeproduct"
          >确 定 兑 换</el-button>
          <el-button
            style="background-color:#99989b;color:#fff;width:100px"
            @click="dialogVisibleExchange = false"
          >取 消</el-button>
        </span>
      </el-dialog>
      <!-- 扫码查找学生 -->
      <el-dialog :visible.sync="dialogVisibleFind" width="30%" center>
        <span>
          <el-form>
            <el-form-item>
              <el-input
                v-model="qrcode"
                placeholder="单行输入"
                ref="sm_input"
                :autofocus="true"
                @input="inputSaoMa"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">请扫描二维码</span>
        </span>
      </el-dialog>
    </el-main>
    <!-- 页码 -->
    <pagination
      :pageObj="pageObj"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></pagination>

    <!-- 兑换成功弹框 -->
    <el-dialog :visible.sync="dialogVisibleSuccess" width="20%">
      <div style="display:flex;flex-direction: column;justify-content: center;align-items: center;">
        <img
          style="border:none;width:120px;height:120px"
          src="../../../../assets/image/other/chenggong.png"
          alt
        />
        <div style="color:#1ccea6;margin-top: 1rem">兑换成功!</div>
        <div style="border:1px solid #cecece">
          即将返回兑换首页
          <span id="time"></span>s
        </div>
      </div>
    </el-dialog>
     <!-- 兑换失败弹框 -->
    <el-dialog :visible.sync="dialogVisibleFail" width="20%">
      <div style="display:flex;flex-direction: column;justify-content: center;align-items: center;">
        <img
          style="border:none;width:120px;height:120px"
          src="../../../../assets/image/other/shibai.png"
          alt
        />
        <div style="color:black;margin-top: 1rem;">兑换失败!</div>
        <div style="border:1px solid #cecece">
          即将返回兑换首页
          <span id="time"></span>s
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import HeaderCrunb from "@/components/HeaderCrunb.vue";
import PopupDel from "@/components/PopupDel.vue";
import Pagination from "@/components/Pagination.vue";
import { postData, postJson, getData } from "../../../../http/fetch";
import { mapState } from "vuex";
import router from "../../../../router";
import woman from "@/assets/image/other/woman_stu.png"
import man from "@/assets/image/other/man_stu.png"
import img from "@/assets/image/other/20220209-172120.png"
export default {
  components: {
    HeaderCrunb,
    Pagination,
    PopupDel,
  },
  data() {
    return {
      pageObj: {
        current: 1,
        total: 0,
        size: 40,
      },
      form: {
        userName: '',
        gradeName: '',
        className: '',
        studentNum: '',
        userId: '',
        currScore: "",
      },
      dialogVisibleExchange: false,
      dialogVisibleFind: false,
      srcUrl: "",
      grade: '',
      classCode: "",
      className: '',
      gradeName: '',
      userName: "",
      keyword: '',
      userId: '',
      xjh:'',
      studentNum: '',
      pageSize: "",
      pageNum: "",
      schoolCode: "",
      commodityCode: '',
      operatorId: '',
      list: [],
      productList: [],
      title: "",
      inventory: "",
      getGradeList: [],
      getClassList: [],
      scoreList: '',
      isShow: false,
      isReadOnly: false,
      dialogVisibleSuccess: false,
      dialogVisibleFail:false,
      qrcode: "",
      imgUrl: "",
    }
  },
  created() {
    const tid = this.$route.query.id
    //console.log(tid)
    postData("/commodity/getCommodityInfoById", {
      id: tid
    }).then((res) => {
      try {
        this.imgUrl = JSON.parse(res.attachUrl).url
      } catch (error) {
        this.imgUrl = res.attachUrl || img
      }
      // this.productList=JSON.parse(res.attachUrl).url;  
      this.scoreList = res.price;
      this.title = res.title;
      this.inventory = res.inventory;
      this.commodityCode = res.commodityCode;
      // console.log(this.productList);
    })
  },
  computed: {
    ...mapState(["userInfo", "setdepositInfo"]),
    crumbList() {
      return [
        { name: "兑换商品库/查找学生", id: 1 },
      ];
    },
  },
  methods: {
    gopage() {
      this.$router.push({
        path: '/exchange'
      })
    },
    onRequest() {
      postJson("/score-order/getUserScoreInfoList", {
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        schoolCode: this.userInfo.schoolCode,
        grade: this.grade,
        classCode: this.classCode,
      }).then((res) => {
        this.list = res.records;
        this.pageObj.total = res.total;
      })
    },
    //传商品信息
    // onProduct(){
    //   postJson("/commodity/getMarketCommodityInfoList",{
    //   pageNum:this.pageObj.current,
    //   pageSize:this.pageObj.size,   
    //   schoolCode:this.userInfo.schoolCode,            
    // }).then((res)=>{ 

    // })
    // },
    getclear(){
      this.search();
    },
     getclearuser(){
      if(this.grade){
        this.search();
      }else{
        this.list=[]
      }
    },
    search() {
      postJson("/score-order/getUserScoreInfoList", {
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        schoolCode: this.userInfo.schoolCode,
        grade: this.grade,
        classCode: this.classCode,
        keyword: this.keyword,
        studentNum: this.studentNum,
      }).then((res) => {
        this.list = res.records;
         this.pageObj.total = res.total; 
      })
    },
    exchangeproduct() {
      this.dialogVisibleExchange = false
      postJson("/score-order/saveStudentExchange", {
        commodityCode: this.commodityCode,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        userId: this.form.userId,
      }).then((res) => {
        //console.log(res)
        this.dialogVisibleSuccess = true;
        var second = 3
        function showTime() {
          second--;
          if (second <= 0) {
            clearInterval(timer)
            // debugger
            router.push({ path: '/exchange' })
            this.dialogVisibleSuccess = false;
          }
          var time = document.getElementById("time");
          time.innerHTML = second + ""
        }
        var timer = setInterval(showTime, 1000);
      }).catch(() => {
         this.dialogVisibleFail = true;
        var second = 3
        function showTime() {
          second--;
          if (second <= 0) {
            clearInterval(timer)
            // debugger
            router.push({ path: '/exchange' })
            this.dialogVisibleFail = false;
          }
          var time = document.getElementById("time");
          time.innerHTML = second + ""
        }
        var timer = setInterval(showTime, 1000);

      })

    },
    //年级下拉框
    GradeList() {
      return postData("/school/getGradeList", {
        schoolCode: this.userInfo.schoolCode,
      }).then((res) => {
        this.getGradeList = res;
        this.grade = this.getGradeList[0].grade
      })
    },
    //班级下拉框
     classList() {
      return getData("/school/getClassInfoList", {
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        grade: this.grade,
        schoolCode: this.userInfo.schoolCode,
      }).then((res) => {
        this.getClassList = res;
        this.classCode = this.getClassList[0].classCode
      })
    },
    exchange(item) {
      this.dialogVisibleExchange = true
      this.form = item
      postJson("/score-order/getUserScoreInfoList", {
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        schoolCode: this.userInfo.schoolCode,
      }).then((res) => {
        //debugger
        //this.list = res.records;
        // form.userName=res.records;

      })
    },
    //判断男女
    getUserLogo(item) {
      if (item.userLogo) {
        return item.userLogo
      } else {
        if (item.userSex == '女') {
          return woman
        } else {
          return man
        }
      }
    },
    //扫码枪
    asycreated() {
      let saomacode = ""
      var _this = this;
      document.onkeydown = function (e) {
        let lastTime, nextTime;
        let lastCode, nextCode;
        if (window.event) { // IE
          nextCode = e.keyCode;
        } else if (e.which) { // Netscape/Firefox/Opera
          nextCode = e.which;
        }
        if (nextCode === 13) {
          //debugger
          if (saomacode.length < 2) return; // 手动输入的时间不会让code的长度大于2，所以这里只会对扫码枪有
          console.log("获取到扫码枪输入的内容", saomacode); // 获取到扫码枪输入的内容，做别的操作
          // debugger
          _this.qrcode = saomacode
          _this.inputSaoMa(saomacode)
          saomacode = '';
          lastCode = '';
          lastTime = '';
          return;
        }
        nextTime = new Date().getTime();
        if (!lastTime && !lastCode) {
          saomacode += e.key;
        }

        if (lastCode && lastTime && nextTime - lastTime > 30) { // 当扫码前有keypress事件时,防止首字缺失
          saomacode = e.key;
        } else if (lastCode && lastTime) {
          saomacode += e.key;
        }
        lastCode = nextCode;
        lastTime = nextTime;
      }
    },

    inputSaoMa(val) {
      if (val === '') return false
      this.isShow = false
      if (this.qrcode === val) {
        console.log('输入完毕')
        this.isShow = true
        this.isReadOnly = true
        postJson("/score-order/getUserScoreInfoList", {
          pageNum: this.pageObj.current,
          pageSize: this.pageObj.size,
          xjh: this.qrcode,
          schoolCode: this.userInfo.schoolCode,
        }).then((res) => {
          this.list = res.records;
          //console.log(res)
        })
      }
    },
    // 分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.onRequest(1, pageSize);
    },
    handleCurrentChange(current) {
      this.pageObj.current = current;
      this.onRequest();
    },

  },
  async mounted() {
    //this.onProduct();
    this.inputSaoMa();
    this.asycreated();
    await this.GradeList();
    await this.classList();
    this.onRequest();

  },
}
</script>
<style lang="less" scoped>
.img-group {
  position: relative;
  display: inline-block;
}

.img-tip {
  width: 100%;
  height: 14%;
  text-align: center;
  position: absolute;
  bottom: 0.3rem;
  background: #1a8b90;
  color: #fff;
  opacity: 0.5;
  font-size: 0.9rem;
  line-height: 1.5rem;
  border-radius: 0 0 0.8rem 0.8rem;
}
.table-phone {
  display: flex;
  flex-wrap: wrap;
}
.product {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  position: relative;
}
.title {
  position: absolute;
  left: 9rem;
  top: 2.2rem;
  font-size: 1rem;
}
.num {
  position: absolute;
  left: 9rem;
  top: 5rem;
  font-size: 1rem;
}
.image {
  margin-left: 1rem;
  width: 7rem;
  height: 8.5rem;
}
img {
  width: 8rem;
  height: 9.5rem;
  border-radius: 0.8rem;
  overflow: hidden;
  border: #75c2b1 2px solid;
}
.phone {
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 8rem;
  height: 13rem;
  margin-right: 0.9rem;
  margin-left: 0.9rem;
  cursor: pointer;
}
.exchange {
  color: #ffcf3e;
  font-weight: 700;
  font-size: 1rem;
  text-decoration: underline;
}
.red {
  color: #8b888b;
  font-size: 1rem;
}
.blue {
  color: #51c3a6;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
.active {
  color: #ffcf3e;
  font-size: 1rem;
  text-decoration: underline;
}
.form-bottom {
  border-bottom: 0.1rem solid #f2f2f2;
  width: 100%;
}
</style>